// import { useState } from "react";
import React, { useState, Fragment, useEffect } from 'react';
// import Fade from 'react-reveal/Fade';
import { connect } from 'react-redux';
import { getData } from '../../services/fetch-service';
import CoBotAvatar from '../CoBotAvatar';
import Options from './Options';

// import Respond from './Respond';

const SearchWidget = (props) => {
  const { locale, search } = props;
  const searchfilter = search.search.toString() !== '' ? `&searchText=${search.search.toString()}` : '';
  const [searchData, setSearchData] = useState([]);

  useEffect(() => {
    setTimeout(() => {
      getData(`Chat/GetChatBoot?Gjuha=${locale}${searchfilter}`)
        .then((response) => {
          const resultData = {
            query: search.search,
            result: response.data,
            notFound: response.status === 404,
          };
          setSearchData((prevData) => [
            ...prevData,
            resultData,
          ]);
        })
        .catch(() => {
          setSearchData((prevData) => [
            ...prevData,
            {
              query: search.search,
              result: null,
              notFound: true,
            },
          ]);
        });
    }, 400);
  }, [search]);

  return (
    <Fragment>
      {searchData.map((searchResult, index) => (
        <Fragment>
          <div className="react-chatbot-kit-user-chat-message-container">
            <div className="react-chatbot-kit-user-chat-message" key={index}>
              {searchResult.query}
              <div className="react-chatbot-kit-user-chat-message-arrow" />
            </div>
            <div className="react-chatbot-kit-user-avatar">
              <div className="react-chatbot-kit-user-avatar-container">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" className="react-chatbot-kit-user-avatar-icon">
                  <path d="M256 288c79.5 0 144-64.5 144-144S335.5 0 256 0 112 64.5 112 144s64.5 144 144 144zm128 32h-55.1c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16H128C57.3 320 0 377.3 0 448v16c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48v-16c0-70.7-57.3-128-128-128z" />
                </svg>
              </div>
            </div>
          </div>
          <div className="react-chatbot-kit-chat-bot-message-container show-message" key={index}>
            <CoBotAvatar />
            <div className="react-chatbot-kit-chat-bot-message">
              {searchResult.notFound ? (
                <span>
                  Rezultati &#39;
                  {searchResult.query}
                  &#39; nuk është gjetur
                </span>
              ) : (
                <span>
                  Rezultati &#39;
                  {searchResult.query}
                  &#39; është gjetur
                </span>
              )}
              <div className="react-chatbot-kit-chat-bot-message-arrow" />
            </div>
          </div>
          {searchResult.result && !searchResult.notFound && <Options options={searchResult.result} title="Options" {...props} />}
        </Fragment>
      ))}
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  locale: state.locale,
});

export default connect(mapStateToProps)(SearchWidget);
